import { Reducer } from 'redux';
import {
	isNullOrUndefined,
	isNullOrUndefinedOrEmptyArray,
	isNullOrUndefinedOrEmptyString,
} from '../../Utils/Various';
import {
	IUserManagementActionTypes,
	IUserManagementState,
	Parent,
	UserACL,
} from './Types';

const initialState: IUserManagementState = {
	allEmail: [],
	allUsernames: [],
	creationParams: [],
	parentsACLData: [],
	usersACLData: [],
	ACLRights: [],
	usersCount: 0,
	lastSearchParams: {
		isGroup: false,
		researchText: '',
		showInactive: false,
		usersParentID: 0,
	},
	lastSearchParamsSorting: {
		sortingBy: 'ID',
		sortingOrder: 'asc',
	},
	userRights: [],
	rightsCount: 0,
	impersonateToken: '',
	isCreationSucceed: false,
	isModificationSucceed: false,
	isLoading: false,
	userCreationIsErrorMsg: '',
	creationParam: {
		dateCreation: '',
		dateDebut: '',
		email: '',
		firstname: '',
		isActive: true,
		isGroup: false,
		language: '',
		localisation: [],
		name: '',
		parentID: -1,
		parentName: '',
		password: '',
		phone: '',
		position: '',
		username: '',
	},
	userToModify: {
		id: -1,
		name: '',
		firstname: '',
		username: '',
		email: '',
		phone: '',
		position: '',
		date_creation: '',
		date_debut: '',
		isactive: false,
		parent: {
			id: 0,
			name: '',
			username: '',
			email: '',
			isactive: false,
			isgroup: false,
		},
		isgroup: false,
		date_expire: '',
		localisation: [],
		language: '',
	},
	userModified: {
		id: -1,
		name: '',
		firstname: '',
		username: '',
		email: '',
		phone: '',
		position: '',
		date_creation: '',
		date_debut: '',
		isactive: false,
		parent: {
			id: 0,
			name: '',
			username: '',
			email: '',
			isactive: false,
			isgroup: false,
		},
		isgroup: false,
		date_expire: '',
		localisation: [],
		language: '',
	},
	usersRetrived: '',
	ACLUsersLoading: false,
	ACLUserLoading: false,
	isRightsLoading: false,
};

const reducer: Reducer<IUserManagementState> = (
	state = initialState,
	action
) => {
	switch (action.type) {
		case IUserManagementActionTypes.CREATE_ACL_USERS_SUCCEED: {
			return {
				...state,
				creationParam: {
					dateCreation: '',
					dateDebut: '',
					email: '',
					firstname: '',
					isActive: true,
					isGroup: false,
					language: '',
					localisation: [],
					name: '',
					parentID: -1,
					parentName: '',
					password: '',
					phone: '',
					position: '',
					username: '',
				},
				isCreationSucceed: true,
				userCreationIsErrorMsg: '',
			};
		}

		case IUserManagementActionTypes.CREATE_ACL_USERS_FAILED: {
			return {
				...state,
				isCreationSucceed: false,
				userCreationIsErrorMsg: action.payload,
			};
		}
		case IUserManagementActionTypes.GET_ALL_ACL_USERS_SUCCEED: {
			return {
				...state,
				allEmail: action.payload[0],
				allUsernames: action.payload[1],
			};
		}
		case IUserManagementActionTypes.GET_ACL_USERS: {
			return {
				...state,
				ACLUsersLoading: true,
			};
		}
		case IUserManagementActionTypes.GET_ACL_USERS_FAILED: {
			return {
				...state,
				ACLUsersLoading: false,
			};
		}
		case IUserManagementActionTypes.MODIFY_ACL_USER_IS_ACTIVE: {
			let user_id = action.payload[1];
			let is_active = action.payload[2];
			let users: UserACL[] = [...state.usersACLData];
			let user: any = users.filter((x) => x.id === user_id)[0];
			if (user) {
				user['isactive'] = is_active;
			}
			return {
				...state,
				usersACLData: users,
			};
		}
		case IUserManagementActionTypes.MODIFY_ACL_USER_DATE_EXPIRE: {
			let user_id = action.payload[1];
			let date_expire = action.payload[2];
			let users: UserACL[] = [...state.usersACLData];
			let user: any = users.filter((x) => x.id === user_id)[0];
			if (user) {
				user['date_expire'] = date_expire;
			}
			return {
				...state,
				usersACLData: users,
			};
		}
		case IUserManagementActionTypes.GET_ACL_USERS_SUCCEED: {
			return {
				...state,
				usersACLData: action.payload.users || [],
				usersCount: action.payload.count,
				ACLUsersLoading: false,
			};
		}
		case IUserManagementActionTypes.GET_ACL_USER_BY_ID: {
			return {
				...state,
				ACLUserLoading: true,
			};
		}
		case IUserManagementActionTypes.GET_ACL_USER_BY_ID_FAILED: {
			return {
				...state,
			};
		}
		case IUserManagementActionTypes.GET_ACL_USER_BY_ID_SUCCEED: {
			// Reception format : 2021-06-09 00:00:00
			// Display format : 09/06/2021 00:00:00

			let dateCreationFormated = '';
			let dateDebutFormated = '';
			let dateFinFormated = '';

			if (
				!isNullOrUndefinedOrEmptyString(
					action.payload.user.date_creation
				)
			) {
				const dateCreation =
					action.payload.user.date_creation.split(' ');

				const dateCreation2 = dateCreation[0].split('-');

				dateCreationFormated =
					dateCreation2[2] +
					'/' +
					dateCreation2[1] +
					'/' +
					dateCreation2[0] +
					' ' +
					'00:00:00';
			}
			if (
				!isNullOrUndefinedOrEmptyString(action.payload.user.date_debut)
			) {
				const dateDebut = action.payload.user.date_debut.split(' ');

				const dateDebut2 = dateDebut[0].split('-');

				dateDebutFormated =
					dateDebut2[2] +
					'/' +
					dateDebut2[1] +
					'/' +
					dateDebut2[0] +
					' ' +
					'00:00:00';
			}

			if (
				!isNullOrUndefinedOrEmptyString(action.payload.user.date_expire)
			) {
				const dateFin = action.payload.user.date_expire.split(' ');

				const dateFin2 = dateFin[0].split('-');

				dateFinFormated =
					dateFin2[2] +
					'/' +
					dateFin2[1] +
					'/' +
					dateFin2[0] +
					' ' +
					'00:00:00';
			}

			let newuser = {
				id: isNullOrUndefined(action.payload.user.id)
					? -1
					: (action.payload.user.id as number),
				name: isNullOrUndefinedOrEmptyString(action.payload.user.name)
					? ''
					: (action.payload.user.name as string),
				firstname: isNullOrUndefinedOrEmptyString(
					action.payload.user.firstname
				)
					? ''
					: (action.payload.user.firstname as string),
				username: isNullOrUndefinedOrEmptyString(
					action.payload.user.username
				)
					? ''
					: (action.payload.user.username as string),
				email: isNullOrUndefinedOrEmptyString(action.payload.user.email)
					? ''
					: (action.payload.user.email as string),
				phone: isNullOrUndefinedOrEmptyString(action.payload.user.phone)
					? ''
					: (action.payload.user.phone as string),
				position: isNullOrUndefinedOrEmptyString(
					action.payload.user.position
				)
					? ''
					: (action.payload.user.position as string),
				date_creation: dateCreationFormated,
				date_debut: dateDebutFormated,
				isactive: isNullOrUndefined(action.payload.user.isactive)
					? false
					: (action.payload.user.isactive as boolean),
				parent: {
					id: isNullOrUndefined(action.payload.user.parent.id)
						? -1
						: action.payload.user.parent.id,
					name: isNullOrUndefinedOrEmptyString(
						action.payload.user.name
					)
						? ''
						: (action.payload.user.parent.name as string),
					username: isNullOrUndefinedOrEmptyString(
						action.payload.user.username
					)
						? ''
						: (action.payload.user.parent.username as string),
					email: isNullOrUndefinedOrEmptyString(
						action.payload.user.email
					)
						? ''
						: (action.payload.user.parent.email as string),
					isactive: isNullOrUndefined(action.payload.user.isactive)
						? false
						: (action.payload.user.parent.isactive as boolean),
					isgroup: isNullOrUndefined(action.payload.user.isactive)
						? false
						: (action.payload.user.parent.isgroup as boolean),
				} as Parent,
				isgroup: isNullOrUndefined(action.payload.user.isactive)
					? false
					: (action.payload.user.isgroup as boolean),
				date_expire: dateFinFormated,
				localisation: isNullOrUndefinedOrEmptyArray(
					action.payload.user.localisation
				)
					? []
					: (action.payload.user.localisation as string[]),
				language: isNullOrUndefinedOrEmptyString(
					action.payload.user.language
				)
					? ''
					: (action.payload.user.language as string),
			} as UserACL;
			return {
				...state,
				userToModify: newuser,
				userModified: newuser,
				ACLUserLoading: false,
			};
		}
		case IUserManagementActionTypes.GET_ACL_PARENTS: {
			return {
				...state,
			};
		}
		case IUserManagementActionTypes.GET_ACL_PARENTS_FAILED: {
			return {
				...state,
			};
		}
		case IUserManagementActionTypes.GET_ACL_PARENTS_SUCCEED: {
			return {
				...state,
				parentsACLData: action.payload.users || [],
			};
		}
		case IUserManagementActionTypes.GET_ACL_RIGHTS: {
			return {
				...state,
			};
		}
		case IUserManagementActionTypes.GET_ACL_RIGHTS_FAILED: {
			return {
				...state,
			};
		}
		case IUserManagementActionTypes.GET_ACL_RIGHTS_SUCCEED: {
			return {
				...state,
				ACLRights: action.payload.Rights || [],
			};
		}

		case IUserManagementActionTypes.GET_USER_RIGHTS: {
			return {
				...state,
			};
		}
		case IUserManagementActionTypes.GET_USER_RIGHTS_FAILED: {
			return {
				...state,
			};
		}
		case IUserManagementActionTypes.GET_USER_RIGHTS_SUCCEED: {
			return {
				...state,
				userRights: action.payload.results || [],
				rightsCount: action.payload.count_total,
			};
		}
		case IUserManagementActionTypes.IMPERSONATE_SUCCEED: {
			return {
				...state,
				impersonateToken: action.payload,
			};
		}
		case IUserManagementActionTypes.IMPERSONATE_FAILED: {
			return {
				...state,
				impersonateToken: '',
			};
		}
		case IUserManagementActionTypes.IS_USER_ALREADY_PRESENT_SUCCEED: {
			return {
				...state,
				usersRetrived: action.payload,
			};
		}
		case IUserManagementActionTypes.IS_LOADING: {
			return {
				...state,
				isLoading: action.payload,
			};
		}
		case IUserManagementActionTypes.SET_LAST_PARAMS: {
			return {
				...state,
				lastSearchParams: action.payload,
			};
		}
		case IUserManagementActionTypes.SET_LAST_PARAMS_SHORTING: {
			return {
				...state,
				lastSearchParamsSorting: action.payload,
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_NAME: {
			return {
				...state,
				userModified: {
					...state.userModified,
					name: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_FIRSTNAME: {
			return {
				...state,
				userModified: {
					...state.userModified,
					firstname: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_USERNAME: {
			return {
				...state,
				userModified: {
					...state.userModified,
					username: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_EMAIL: {
			return {
				...state,
				userModified: {
					...state.userModified,
					email: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_PARENT: {
			return {
				...state,
				userModified: {
					...state.userModified,
					parent: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_PHONE_NUMBER: {
			return {
				...state,
				userModified: {
					...state.userModified,
					phone: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_POSITION: {
			return {
				...state,
				userModified: {
					...state.userModified,
					position: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_LOCALISATION: {
			return {
				...state,
				userModified: {
					...state.userModified,
					localisation: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_LANGUAGE: {
			return {
				...state,
				userModified: {
					...state.userModified,
					language: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_START_DATE: {
			return {
				...state,
				userModified: {
					...state.userModified,
					date_debut: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_END_DATE: {
			return {
				...state,
				userModified: {
					...state.userModified,
					date_expire: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_USER_ACTIVE: {
			return {
				...state,
				userModified: {
					...state.userModified,
					isactive: action.payload,
				},
			};
		}
		case IUserManagementActionTypes.SET_RIGHTS_LOADING: {
			return {
				...state,
				isRightsLoading: action.payload
			};
		}
		case IUserManagementActionTypes.MODIFY_ACL_USER_IS_ACTIVE_SUCCEED: {
			// Si c'est une désactivation (suppression)
			if (!action.payload) {
				return {
					...state,
					usersACLData: state.usersACLData.filter(user => user.id !== action.meta.userId),
					usersCount: state.usersCount - 1
				};
			}
			return state;
		}
		default: {
			return state;
		}
	}
};

export { reducer as UserManagementReducer };
